<div class="avatar-name-box" style="display: flex; flex-direction: row; vertical-align: middle; align-items: center;">
  <div class="avatar">
    <div
      class="user-avatar-inline"
      [class.user-avatar-inline--round]="true"
    >
      <img
        *ngIf="displaySrc; else fallback"
        [src]="displaySrc"
        alt="avatar"
        (error)="onImgError()"
      />
      <ng-template #fallback>
        <span class="user-avatar-inline__initial" aria-hidden="true">{{ initial }}</span>
      </ng-template>
    </div>
  </div>
  <div class="mx-3" style="font-size: 16px; color: #3f4258;">
    <strong>{{ user?.fname }} {{ user?.lname }}</strong>
  </div>
</div>
